(function () {
  angular.module("akitabox.desktop.building.admin.job", [
    "akitabox.constants",
    "akitabox.core.services.flag",
    "akitabox.core.services.job",
    "akitabox.core.toast",
    "akitabox.ui.dialogs.job.create",
  ]);
})();
